export const MAIN_NAV_VISIBLE = 'mainNav/main-nav'
export const BG_VISIBLE = 'mainNav/bg-visible'
export const RIBBON_VISIBLE = 'mainNav/ribbon-visible'
export const IS_DRAGGING = 'mainNav/is-dragging'
export const IS_IN_HOME = 'mainNav/is-in-home'
export const BG_ACTIVE_INDEX = 'mainNav/active-index'

const state = {
    mainNavVisible: false,
    backgroundVisible: false,
    ribbonVisible: false,
    isDragging: false,
    isInHome: false,
    activeIndex: 0,
};

const actions = {};

const mutations = {
    [MAIN_NAV_VISIBLE](state, payload) {
        state.mainNavVisible = payload;
    },
    [BG_VISIBLE](state, payload) {
        state.backgroundVisible = payload;
    },
    [RIBBON_VISIBLE](state, payload) {
        state.ribbonVisible = payload;
    },
    [IS_DRAGGING](state, payload) {
        state.isDragging = payload;
    },
    [IS_IN_HOME](state, payload) {
        state.isInHome = payload;
    },
    [BG_ACTIVE_INDEX](state, payload) {
        state.activeIndex = payload;
    }
};

const getters = {
    mainNavVisible: state => state.mainNavVisible,
    backgroundVisible: state => state.backgroundVisible,
    ribbonVisible: state => state.ribbonVisible,
    isDragging: state => state.isDragging,
    isInHome: state => state.isInHome,
    activeIndex: state => state.activeIndex,
};

export default {state, actions, mutations, getters}



// WEBPACK FOOTER //
// ./src/app/store/modules/background.js